import { buttonStyles } from './Button.styles';
import type { ButtonSize, ButtonVariant } from './Button.types';
import { cn } from '../../../utils/className';

export const getButtonClasses = (
  variant: ButtonVariant = 'primary',
  size: ButtonSize = 'md',
  fullWidth?: boolean,
  loading?: boolean,
  className?: string
): string => {
  return cn(
    buttonStyles.base,
    buttonStyles.variants[variant],
    buttonStyles.sizes[size],
    fullWidth && buttonStyles.modifiers.fullWidth,
    loading && buttonStyles.modifiers.loading,
    className
  );
};
